const classnames = (...classes) =>
  classes.flat(Number.POSITIVE_INFINITY).filter(Boolean).join(" ");

export default classnames;
